<template>
  <div style="background-color: white">
    <el-row style="padding-top: 10px">
      <el-col :span="24">
        <el-button
          size="small"
          class="btn"
          type="primary"
          v-if="show.qr"
          @click="handleCreate"
          >检定确认</el-button
        >
        <el-button
          size="small"
          class="btn"
          type="success"
          v-if="show.qr"
          @click="batchConfirm"
          >批量确认</el-button
        >
        <el-form
          :inline="true"
          ref="deviceInfo"
          :model="deviceInfo"
          class="demo-form-inline"
          style="float: right !important"
        >
          <el-form-item label="筛选单位">
            <el-cascader
              v-model="deviceInfo.companyCode"
              :options="companyTree"
              :show-all-levels="false"
              :props="props"
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item label="日期">
            <el-date-picker
              v-model="deviceInfo.date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-input
              v-model="deviceInfo.content"
              auto-complete="off"
              placeholder="请输入搜索内容"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="findAllClick"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-table
          :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
          :cell-style="{ textAlign: 'center' }"
          ref="multipleTable"
          :data="checkData"
          tooltip-effect="dark"
          style="width: 100%; text-align: center"
          stripe
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            :label="lable.index"
            type="index"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{ scope.$index + (pageIndex - 1) * pagesize + 1 }}</span>
            </template></el-table-column
          >
          <el-table-column
            prop="id"
            sortable
            :label="lable.id"
            show-overflow-tooltip
          >
            <template slot-scope="scope" show-overflow-tooltip>
              <el-link
                :underline="false"
                @click="onClick(scope.row)"
                style="color: #4095e5; text-decoration: none"
              >
                {{ scope.row.id }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="glbh"
            sortable
            :label="lable.glbh"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="jdsb"
            sortable
            :label="lable.jdsb"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="ssdw"
            sortable
            :label="lable.companyName"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            sortable
            prop="checkCertificate"
            :label="lable.checkCertificate"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            sortable
            prop="checkTime"
            :label="lable.checkTime"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="jg"
            sortable
            :label="lable.jg"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="nextCheckTime"
            sortable
            :label="lable.nextCheckTime"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="checkStatue"
            sortable
            :label="lable.statue"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.checkStatue == '已确定'"
                style="color: #4095e5"
                >在用</span
              >
              <span v-else style="color: blueviolet">待确定</span>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top: 5px; height: 35px">
        <el-pagination
          v-if="checkData.length > 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="float: right"
        >
        </el-pagination>
      </el-col>
    </el-row>

    <el-dialog title="批量确认" :visible.sync="batchDialog" width="420px" :append-to-body="true"
      :close-on-click-modal="false" :close-on-press-escape="false" :show-close="!batchLoading">
      <el-form label-width="90px" v-loading="batchLoading" element-loading-text="正在批量确认，请稍候...">
        <el-form-item label="检定结果">
          <el-select v-model="batchJg" style="width: 100%" :disabled="batchLoading">
            <el-option v-for="item in jgOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <span style="color: #909399">将对勾选的 {{ batchIds.length }} 条记录统一按该结果确认，请确认证书已核对。</span>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="batchDialog = false" :disabled="batchLoading">取 消</el-button>
        <el-button type="primary" @click="submitBatchConfirm" :loading="batchLoading">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  selectAllCheck,
  findByModule,
  findByUserIdCompanyTree,
  confirmCheckBatch,
} from "../../api/api";
export default {
  name: "VerificationAffirm",
  data() {
    return {
      companyTree: [],
      deviceInfo: {
        date: [],
        content: "",
        state: "",
      },
      props: {
        checkStrictly: true,
        label: "companyName",
        value: "companyCode",
        children: "zcompany",
        emitPath: false,

      },
      show: {
        qr: false,
      },
      lable: {},
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      options: [],
      checkData: [],
      multipleSelection: [],
      batchDialog: false,
      batchLoading: false,
      batchJg: "符合要求",
      batchIds: [],
      jgOptions: [
        { value: "符合要求", label: "符合要求" },
        { value: "部分符合要求", label: "部分符合要求" },
        { value: "不符合要求", label: "不符合要求" },
      ],
    };
  },
  methods: {
    findAllClick() {
      this.pageIndex = 1;
      this.findAll();
    },
    handleCreate() {
      let currentSelect = this.$refs.multipleTable.selection;
      if (currentSelect.length > 1) {
        this.$message.warning("只能选择一条信息"); // .....失败信息
      } else if (currentSelect.length == 1) {
        let val = {
          path: "/Submit",
          name: "确认详情",
        };
        sessionStorage.setItem("jdid", currentSelect[0].id);
        this.$router.push({
          path: "Submit",
        });
        this.$store.commit("pushtags", val);
      } else {
        this.$message.warning("请选择设备"); // .....失败信息
      }
    },
    onClick(row) {
      if (this.show.qr) {
        let val = {
          path: "/Submit",
          name: "确认详情",
        }; // debugger //保存数据
        sessionStorage.setItem("qrvar", true);
        sessionStorage.setItem("jdid", row.id);
        this.$router.push({
          path: "Submit",
        });
        this.$store.commit("pushtags", val);
      } else {
        this.$message.warning("您不具有确认权限");
      }
    },
    //批量确认
    batchConfirm() {
      let currentSelect = this.$refs.multipleTable.selection;
      if (currentSelect.length < 1) {
        this.$message.warning("请勾选需要确认的记录");
        return;
      }
      this.batchIds = currentSelect.map((item) => item.id);
      this.batchJg = "符合要求";
      this.batchDialog = true;
    },
    submitBatchConfirm() {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      this.batchLoading = true;
      confirmCheckBatch({
        ids: this.batchIds.join(","),
        jg: this.batchJg,
        userId: userinfo.userId,
      }).then(datas => {
        this.batchLoading = false;
        let { status, message, data } = datas;
        if (status == 200) {
          this.$message.success(data);
          this.batchDialog = false;
          this.findAll();
        } else {
          this.$message.error(message || "请求错误");
        }
      }).catch(() => {
        this.batchLoading = false;
        this.$message.error("请求错误");
      });
    },

    //查询信息
    findAll() {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      if (sessionStorage.getItem("qrvar") == "true") {
        if (sessionStorage.getItem("affirmIndex") != undefined) {
          this.pageIndex = sessionStorage.getItem("affirmIndex") * 1;
          if (sessionStorage.getItem("qrvar") == "true") {
            sessionStorage.setItem("qrvar", false);
          }
        }
      }
      let map = {
        start: this.deviceInfo.date == null ? null : this.deviceInfo.date[0],
        end: this.deviceInfo.date == null ? null : this.deviceInfo.date[1],
        content: this.deviceInfo.content,
        state: 1,
        jdlx: 0,
        userId: userinfo.userId,
        pageIndex: this.pageIndex,
        pageSize: this.pagesize,
        companyCode:this.deviceInfo.companyCode
      };
      selectAllCheck(map).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.checkData = data.list;
          this.total = data.total;
        }
      });
    },

    //分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      sessionStorage.setItem("affirmIndex", val);
      //contentdata是所有的数据，是一个大数组。使用.slice()方法可以将大数组切分
      //.slice()方法接受两个参数，开始和结束的值
      //这样得到的currentdata就是固定只有10个值的数组了，就可以用v-for展示啦
      this.findAll();
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.findAll();
    },
    findLable() {
      findByModule("设备检定").then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.lable = data;
        }
      });
    },
    getCompanyTree() {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      var  companyCode='';
      if (userinfo.userRole == 1 || (userinfo.fjqx != null && (userinfo.fjqx.indexOf ("3")!=-1||userinfo.fjqx.indexOf ("4")!=-1))) {
        companyCode="-1"
      }else{
        companyCode=userinfo.companyCode
      }
      findByUserIdCompanyTree(companyCode).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.companyTree = this.getTreeData(data);
        }
      });
    },
    getTreeData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].zcompany.length < 1) {
          // 最后一级没有数据将children变成undefined
          data[i].zcompany = undefined;
        } else {
          // children不为空时继续调用该方法
          this.getTreeData(data[i].zcompany);
        }
      }
      return data;
    },
  },
  created() {
    this.findLable();
    this.findAll();
    this.getCompanyTree();
    var userinfo = JSON.parse(localStorage.getItem("user"));
    var arr = userinfo.role.menuId.split(",");
    arr.forEach((i) => {
      if (i == "92") {
        this.show.qr = true;
      }
    });
  },
  // keep-alive 缓存后重新激活时，保留搜索条件刷新列表
  activated() {
    this.findAll();
  },
};
</script>
<style >
.el-checkbox__inner {
  border: 1px solid #606266 !important;
}
</style>
<style scoped>
.btn {
  float: left;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/verification/Affirm.vue